import apiService from '../../../services/api'

/**
 * UZS2 (Узбекистан, провайдер Exotic) API
 * Оплата через P2P перевод на карту
 * В отличие от uzs1, всегда возвращает реквизиты карты (не ссылку)
 */

export const fetchUzs2Config = async () => {
  try {
    const response = await apiService.makeRequest('/api/uzs2/')

    if (response.uzs) {
      return { ...response.uzs, promo: response.promo || null }
    }

    throw new Error('Invalid response format: uzs2 config not found')
  } catch (error) {
    console.error('Error fetching UZS2 config:', error)
    throw error
  }
}

export const fetchUzs2Packages = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg.uzs2 !== undefined)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching UZS2 packages:', error)
    throw error
  }
}

const normalizeUzs2CreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error sum') return 'INVALID_AMOUNT'
  if (response.error === 'error backend') return 'BACKEND_ERROR'
  if (response.error === 'error limit') return 'LIMIT_ORDER'

  return response.error
}

export const createPaymentByUzs = async (uzs) => {
  try {
    const response = await apiService.makeRequest('/api/uzs2/', {
      method: 'POST',
      body: JSON.stringify({ uzs })
    })

    const normalizedError = normalizeUzs2CreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.order_id && response.number_card && response.fio) {
      return response
    }

    throw new Error('Invalid response format: payment details not found')
  } catch (error) {
    console.error('Error creating UZS2 payment by uzs:', error)
    throw error
  }
}

export const createPaymentByCrystals = async (crystals) => {
  try {
    const response = await apiService.makeRequest('/api/uzs2/', {
      method: 'POST',
      body: JSON.stringify({ crystal: crystals })
    })

    const normalizedError = normalizeUzs2CreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.order_id && response.number_card && response.fio) {
      return response
    }

    throw new Error('Invalid response format: payment details not found')
  } catch (error) {
    console.error('Error creating UZS2 payment by crystals:', error)
    throw error
  }
}

export default {
  fetchUzs2Config,
  fetchUzs2Packages,
  createPaymentByUzs,
  createPaymentByCrystals
}
